import { Box, Typography } from "@mui/material";
import React from "react";

type TextBoxProps = {
  text: string;
  variant: "body1" | "h1" | "h2" | "h3" | "h4" | "subtitle1" | "subtitle2";
  color?: "primary" | "secondary" | "initial" | "textPrimary" | "textSecondary";
  classes?: string;
  boxProps?: any;
};

export const TextBox: React.FC<TextBoxProps> = ({
  text,
  variant,
  color,
  classes,
  boxProps,
}) => {
  return (
    <Box {...boxProps}>
      <Typography variant={variant} color={color} className={classes}>
        {text}
      </Typography>
    </Box>
  );
};
